import React from 'react';
import { Check, AlertCircle } from 'lucide-react';
import { ABLE_COLORS } from '../../../constants';

/**
 * RecipeCard - Displays a single recipe match
 * Shows what you have, what's missing, and tips
 */
export default function RecipeCard({ recipe }) {
  const { 
    name, 
    description, 
    tips, 
    canMake, 
    hasIngredients = [], 
    missingRequired = [],
    optionalMatches = []
  } = recipe;

  return (
    <div style={{
      background: ABLE_COLORS.neutral,
      borderRadius: ABLE_COLORS.cardRadiusLarge,
      border: `1px solid ${ABLE_COLORS.border}`,
      padding: '16px',
      width: '100%',
      boxSizing: 'border-box'
    }}>
      {/* Header */}
      <div style={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        marginBottom: '8px'
      }}>
        <h3 style={{
          margin: 0,
          fontSize: '16px',
          fontWeight: '600',
          color: ABLE_COLORS.textPrimary
        }}>
          {name}
        </h3>
        
        {canMake && (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            color: ABLE_COLORS.success,
            fontSize: '12px',
            fontWeight: '500'
          }}>
            <Check size={14} />
            Ready
          </div>
        )}
      </div>

      {/* Description */}
      <p style={{
        margin: '0 0 12px 0',
        fontSize: '14px',
        color: ABLE_COLORS.textSecondary,
        lineHeight: '1.4'
      }}>
        {description}
      </p>

      {/* Ingredients you have */}
      {hasIngredients.length > 0 && (
        <div style={{
          fontSize: '13px',
          color: ABLE_COLORS.success,
          marginBottom: '6px',
          display: 'flex',
          alignItems: 'flex-start',
          gap: '6px'
        }}>
          <Check size={14} style={{ marginTop: '2px', flexShrink: 0 }} />
          <span>You have: {hasIngredients.join(', ')}</span>
        </div>
      )}

      {/* Optional matches */}
      {optionalMatches.length > 0 && (
        <div style={{
          fontSize: '13px',
          color: ABLE_COLORS.textMuted,
          marginBottom: '6px'
        }}>
          Could add: {optionalMatches.join(', ')}
        </div>
      )}

      {/* Missing ingredients */}
      {missingRequired.length > 0 && (
        <div style={{
          fontSize: '13px',
          color: ABLE_COLORS.coral,
          marginBottom: '6px',
          display: 'flex',
          alignItems: 'flex-start',
          gap: '6px'
        }}>
          <AlertCircle size={14} style={{ marginTop: '2px', flexShrink: 0 }} />
          <span>Missing: {missingRequired.join(', ')}</span>
        </div>
      )}

      {/* Tips */}
      {tips && (
        <div style={{
          marginTop: '10px',
          paddingTop: '10px',
          borderTop: `1px solid ${ABLE_COLORS.border}`,
          fontSize: '12px',
          color: ABLE_COLORS.textMuted,
          fontStyle: 'italic'
        }}>
          💡 {tips}
        </div>
      )}
    </div>
  );
}
